const appName = 'lp-le-custom-management-console';
const appCode = 'cmc';

const __mcFeatureBEurl = {
    qa: 'mcfeature-app.qa.int.gw.lpcloud.io',
    z0: 'mcfeature-app.qa.int.gw.lpcloud.io',
    'z1-a': 'z1-a.mcfeature.liveperson.net',
    z1: 'z1.mcfeature.liveperson.net',
    z2: 'z2.mcfeature.liveperson.net',
    z3: 'z3.mcfeature.liveperson.net',
    default: 'z1.mcfeature.liveperson.net',
};

export { appCode, appName, __mcFeatureBEurl };
